import styled from 'styled-components';
import Link from 'gatsby-link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Css
import { Family } from '../../Css/Font';
import { SCREEN } from '../../../assets/styles/constants';

// Atoms
import { flex } from '../../../assets/styles/flex-grid';
import { FONT_SIZE } from '../../../assets/styles/font';

export const FooterWrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	background: #171C3B;
`;

export const FooterFirstFooter = styled.div`
	${flex};
	justify-content: space-around;
	align-items: center;
	padding: 70px;
	box-shadow: 0px -6px 7px -5px rgba(204, 204, 204, 0.5);
	
	${SCREEN.MEDIUM} {
		flex-direction: column;
		padding: 30px 15px 30px;
	}
	
	${SCREEN.SMALL} {
		padding: 60px 0;
	}
`;

export const FooterSecondFooter = styled.div`
	${flex};
	width: 100%;
	justify-content: center;
	padding: 20px 70px;
`;

export const FooterCopyright = styled.div`
	${FONT_SIZE.TAG};
	color: #ffffff;
	text-align: center;
	white-space: nowrap;
`;

export const FooterSocialMediaLinkWrapper = styled.a`
	border-radius: 50%;
`;

export const FooterContentWrapper = styled.div`
	${flex};
	flex-direction: column;
	color: #fff;
	width: auto;
	${SCREEN.MEDIUM} {
		align-items: center;
		width: 100%;
	}
`;

export const FooterTitle = styled.h3`
	text-transform: uppercase;
	color: #ffffff;
	
	font-weight: 700;
	font-size: 14px;
	margin-bottom: 40px;
	letter-spacing: 1px;
	${SCREEN.MEDIUM} {
		margin-top: 30px;
		margin-bottom: 10px;
	}
`;

export const FooterLink = styled(Link)`
	${Family.ProximaNovaNormal};
	${props => (props.green ? 'color: #1FA59A' : 'color: #ffffff')};
	text-decoration: none;
	font-size: ${props => (props.fontSize ? '12px' : '16px;')};
	font-weight: 400;
	margin-bottom: 15px;
	display: flex;
	align-items: center;

	&:hover {
		opacity: 1;
	}
`;

export const FooterBeforeFooter = styled(FooterContentWrapper)`
	background-color: #fafafa;
	padding: 70px 0;
	align-items: center;
	box-shadow: 0px -6px 7px -5px rgba(204,204,204,0.5);
	${SCREEN.SMALL} {
		padding: 0 0 45px 0;
	}

`;

export const FooterBeforeFooterTitle = styled(FooterTitle)`
	color: white;
	text-align: center;
`;

FooterLink.External = styled.a`
	${Family.ProximaNovaNormal};
	${props => (props.green ? 'color: #1FA59A' : 'color: #ffffff')};
	text-decoration: none;
	margin-bottom: 15px;
	display: flex;
	align-items: center;
`;

export const FooterFontAwesome = styled(FontAwesomeIcon)`
	max-height: 16px;
	margin-right: 5px;
`;
